export function getInitials(name?: string | null) {
  if (!name) return null;
  const names = name.split(' ');
  return names[0].trim().charAt(0) + names[1].trim().charAt(0) ?? '';
}
